import { Navigate } from 'react-router-dom'
import { usePortalStore } from '@/stores/portal.store'
import { Loader2 } from 'lucide-react'
import { useState, useEffect } from 'react'

export function AssociateProtectedRoute({ children }: { children: React.ReactNode }) {
    const { associado } = usePortalStore()
    const [checking, setChecking] = useState(true)

    useEffect(() => {
        // Pequeno delay para garantir que o estado persistido do Zustand foi carregado
        const timer = setTimeout(() => setChecking(false), 300)
        return () => clearTimeout(timer)
    }, [])

    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-surface-950">
                <Loader2 size={32} className="animate-spin text-primary-600" />
            </div>
        )
    }

    if (!associado) {
        return <Navigate to="/portal/login" replace />
    }

    return <>{children}</>
}
